// extracted by mini-css-extract-plugin
module.exports = {"dodaPrime":"dodaPrime","dodaPrime__video":"dodaPrime__video"};